/* Scan session context — persisted through registration and email verification. */

const KEY = 'scalitos_scan';
const MAX_AGE_MS = 48 * 60 * 60 * 1000;

export const getScanContext = () => {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data.token) return null;
    if (data.ts && Date.now() - data.ts > MAX_AGE_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return data;
  } catch (e) {
    return null;
  }
};

export const clearScanContext = () => {
  try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
};
